import { transitionZoomLevel } from 'utils/apple-maps';
import { AutocompletePredictionPredictionCategory, SearchPredictionSource } from './google-maps/types';

export const PROVINCE_STATE_ZOOM_LEVEL = 5;
export const MILITARY_BASE_ZOOM_LEVEL = 12;

export default function determineZoomLevel(prediction: any) {
  let zoom = transitionZoomLevel;

  if (prediction.label === AutocompletePredictionPredictionCategory.NEIGHBORHOOD) {
    zoom = 15;
  }

  if (prediction.source === SearchPredictionSource.GOOGLE && prediction.label === AutocompletePredictionPredictionCategory.STREET) {
    zoom = 16;
  }

  // If the prediction is a military base, use the military base zoom level
  if (prediction.label === AutocompletePredictionPredictionCategory.MILITARY) {
    zoom = MILITARY_BASE_ZOOM_LEVEL;
  }

  // If the prediction is a province, zoom out to show the entire province
  if (prediction.label === AutocompletePredictionPredictionCategory.PROVINCE) {
    zoom = PROVINCE_STATE_ZOOM_LEVEL;
  }

  return zoom;
}